import { TYPE_BILL_ITEM } from '../../../constants/types';
import { Billable } from '../Billing/types';
import { IPharmacyItem } from './types';

/** Map pharmacy inventory rows to billables for BillItems autocomplete (SHER-378). */
export function pharmacyItemsToBillables(items: IPharmacyItem[]): Billable[] {
    const seenIds = new Set<number>();
    const seenNames = new Set<string>();

    return items
        .filter((item) => {
            const id = item.id as number;
            if (seenIds.has(id)) {
                return false;
            }
            const normalizedName = String(item.name ?? '').trim().toLowerCase();
            if (normalizedName && seenNames.has(normalizedName)) {
                return false;
            }
            seenIds.add(id);
            if (normalizedName) {
                seenNames.add(normalizedName);
            }
            return true;
        })
        .map((item) => ({
            id: item.id as number,
            concept: String(item.name ?? ''),
            amount: item.price ?? 0,
            type: TYPE_BILL_ITEM.PHARMACY_ITEM,
            quantity: item.amount,
        }));
}
